/**
 * ============================================================
 * AuthFetch.js — Wrapper around fetch() with Auth Handling
 * ============================================================
 *
 * Automatically attaches the JWT token from localStorage
 * to every request as an Authorization: Bearer <token> header.
 * Centralizes all authentication logic in one place.
 *
 * - Uniformly intercepts expired or invalid tokens (401/403).
 *   When detected:
 *   -> Removes token
 *   -> Redirects user back to /admin login page
 *   -> Prevents further processing of the request
 **/

export async function authFetch(url, options = {}) {
  // Ensure Authorization header is always attached
  const token = localStorage.getItem("token");

  // Merge given options with the Authorization header
  const finalOptions = {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`
    }
  };

  // Execute the request
  const res = await fetch(url, finalOptions);

  // Handle invalid or expired token
  // res.status === 401 -> unauthorized (invalid/expired token)
  // res.status === 403 -> forbidden (token exists but insufficient permission)
  // In both cases: wipe token + redirect to login page.
  if (res.status === 401 || res.status === 403) {
    console.warn("Token expired or invalid — redirecting to /admin");

    // Remove invalid token
    localStorage.removeItem("token");

    // Redirect to login page
    window.location.href = "/admin";

    // Stop further execution
    return;
  }

  // Normal response continues
  return res;
}
